<template>
  <el-col :span="24" id="companies">
    <el-row type="flex" justify="start" align="middle" id="companies-header">
      <HeaderInfoText :colspan="9" title="COMPANIES" :meta="meta"></HeaderInfoText>
      <el-col :span="6">
        <el-row type="flex" justify="center" v-if="meta.count > 20">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="meta.count"
            :page-size="20"
            v-model:current-page="currentPage">
          </el-pagination>
        </el-row>
      </el-col>
      <el-col :span="9" class="h-padded right-aligned-col">
        <!--<el-button type="primary" icon="plus" @click="createNewModel"></el-button>-->
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" align="middle">
      <el-col :span="24">
        <el-table
          v-if="!receiving && meta.count"
          id="companies-table"
          :data="pageData"
          border
          style="width: 100%; z-index: 0;"
          :maxHeight="tableHeight"
          :ref="`${endpoint}Table`"
          :row-class-name="tableRowClassName">
          <el-table-column prop="code" label="Code" align="center" width="120">
            <template v-slot="scope">
              <el-row type="flex" justify="center">
                <a class="link-mock" @click="editExistingModel(scope.row.id)">
                  {{ scope.row.code }}
                </a>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="Name" align="left" fit>
            <template v-slot="scope">
              <el-row type="flex">
                <a class="link-mock" @click="editExistingModel(scope.row.id)">
                  {{ scope.row.name }}
                </a>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="postable" label="Postable" align="center" width="200">
            <template v-slot="scope">
              <el-tag :type="scope.row.postable ? 'success' : 'danger'" close-transition>
                {{ scope.row.postable ? 'Yes' : 'No' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog
      :title="editMode.active ? hasCreatePermission ? `Edit Company` : 'View Company' : 'Create New Company'"
      width="45%"
      v-model="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false">
      <NewEntityForm
        :modalOpen="dialogFormVisible"
        :fields="fields"
        v-model:form="form"
        :idPrefix="'a-'"
        ref="form"
        @formChanged="handleFormChange"
      />
      <template v-slot:footer><span class="dialog-footer">
      <el-button :disabled="saving || !!updating" @click="closeFormModal">Cancel</el-button>
      <el-button :disabled="!hasCreatePermission" :loading="saving || !!updating" type="primary" @click="submitAddresses">Submit</el-button>
    </span></template>
    </el-dialog>
  </el-col>
</template>

<script>
  import store from '@/store/store'
  import { mapGetters } from 'vuex'
  import { payload } from '@/components/RouteComponents/Companies/actionPayload'
  import NewEntityForm from '@/components/NewEntityForm.vue'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import getUniqueValues from '@/utils/helpers/GetUniqueValues'
  import { validate, checkAddressRequirements } from '@/utils/helpers/Validate'
  import { notify } from '@/utils/helpers/Notify'
  import { createNewModel } from '@/components/RouteComponents/commonFunctions'
  import { systemViewMixins } from '@/Mixins/SystemViewMixins'
  import { DataLoader } from '@/utils/helpers/DataLoader/DataLoader'
  import cityMixin from '@/Mixins/CityMixin'
  import { randomHex } from '@/utils/randomHex'

  export default {
    components: {
      NewEntityForm,
      HeaderInfoText
    },
    mixins: [ systemViewMixins, cityMixin ],
    data () {
      return {
        tableHeight: 1000,
        batchUpdateOptions: [
          { id: 0, text: 'View account balances' },
          { id: 1, text: 'View in cost manager' },
          { id: 2, text: 'Set as postable' },
          { id: 3, text: 'Convert names to Title Case' },
          { id: 4, text: 'Convert names to UPPER Case' }
        ],
        batchUpdateSelection: null,
        dialogFormVisible: false,
        formInitState: {
          code: '',
          name: '',
          tax_id: '',
          address: '',
          address_line1: '',
          address_line2: '',
          address_city: '',
          address_state: { label: '', value: '' },
          address_postal: '',
          phone: '',
          active: true,
          comments: '',
          bank: '',
          contact_name: '',
          email: ''
        },
        form: {
          code: '',
          name: '',
          tax_id: '',
          address: '',
          address_line1: '',
          address_line2: '',
          address_city: '',
          address_state: { label: '', value: '' },
          address_postal: '',
          phone: '',
          active: true,
          comments: '',
          bank: '',
          contact_name: '',
          email: ''
        },
        isCityModel: undefined,
        editMode: { active: false, modelId: null },
        changingPage: false
      }
    },
    methods: {
      getUniqueValues,
      /**
       * Submits addresses
       */
      async submitAddresses () {
        let all = this.fields.filter(v => v.name.includes('address'))
        const hasAtLeastOneField = all.some(v => {
          if (this.form[v.name].hasOwnProperty('value')) return !!this.form[v.name].value
          return !!this.form[v.name]
        })
        const isValid = checkAddressRequirements(all, this.form)
        if (!hasAtLeastOneField || !isValid) {
          return notify(this, 'warning', 'Please specify valid address attributes')
        }
        let subsetForm = {}
        for (let i = 0; i < all.length; i++) {
          const name = all[i].name.split('_')[1]
          const val = this.form[all[i].name]
          subsetForm[name] = val.hasOwnProperty('value') ? val.value : val
        }
        if (this.isCityModel && typeof subsetForm.city === 'string') {
          let cityId = await this.getCityByNameAndState(subsetForm.city, subsetForm.state)
          if (cityId) {
            subsetForm.city = cityId
          } else {
            // Create City
            let payload = {
              name: subsetForm.city,
              code: `${randomHex(5)}`,
              state: subsetForm.state
            }
            let cityId = await this.addNewCity(payload)
            subsetForm.city = cityId
          }
        }
        this.form.address = subsetForm
        if (this.form.hasOwnProperty(`address_id`)) {
          this.form.address['id'] = this.form[`address_id`]
        }
        this.submitForm()
      },
      /**
       * Submits the form
       */
      async submitForm () {
        let form = { ...this.form }
        for (let f in this.form) {
          if (f === 'active') {
            continue
          }
          if (f.includes('address_')) {
            delete form[f]
          }
        }
        let validationErrors = validate(form, this.fields)
        if (!validationErrors.messages) {
          form = this.handleNestedValueFields(form)
          form = this.formatPostOrPatchRequest(form)
          try {
            for (let f in form) {
              if (typeof form[f] === 'number') {
                form[f] = form[f].toString()
              }
            }
            let newPayload = { ...payload, id: this.editMode.modelId, data: form }
            const resp = await this.$store.dispatch(this.editMode.active ? 'update' : 'save', newPayload)
            if (!(resp && resp.id)) {
              throw new Error()
            }
            this.dialogFormVisible = false
            this.resetForm()
            this.createdNotif = this.$notify({
              title: 'Success',
              message: `Company ${resp.name ? resp.name : resp.code} saved. Click to view.`,
              type: 'success',
              onClick: () => {
                this.editExistingModel(resp.id)
                this.createdNotif.close()
                this.createdNotif = null
              }
            })
            this.highlightNewModel(resp.id)
            return resp
          } catch (e) {
            console.log(e)
            notify(this, 'error', 'Error saving company')
            this.$notify({ title: 'Error', message: `Error saving company.`, type: 'error' })
          }
        } else {
          let offset = 0                                                                        // Set offset so that notifs don't overlap each other
          validationErrors.messages.map(v => {                                                  // Render validation error notifs
            notify(this, 'warning', v, offset)
            offset += 100
          })
        }
      },
      /**
       * Handles updates to the form
       * @param targetField
       */
      handleFormChange (targetField) {
        this.trackFormChange()
      },
      /**
       * Resets editMode data, resets form to initial state, and displays the
       * modal to create a new model
       */
      createNewModel () {
        createNewModel(this)
      },
      /**
       * Handles editing an existing company
       * @param modelId   The id of the company that is being edited
       */
      async editExistingModel (modelId) {
        this.editMode.active = true
        this.editMode.modelId = modelId
        const model = this.getById(modelId)
        for (let p in model) {
          if (!model.hasOwnProperty(p) || !Object.keys(this.form).includes(p)) continue
          if (p === 'address') {
            const addressModel = this.getAddressById(model[p])
            if (model.address && addressModel) {
              for (let a in addressModel) {
                if (a === 'state' && this.getStateById(addressModel[a])) {
                  this.form[p + `_${a}`]['label'] = this.getStateById(addressModel[a]).name
                  this.form[p + `_${a}`]['value'] = this.getStateById(addressModel[a]).id
                } else if (a === 'city' && this.isCityModel && typeof addressModel[a] === 'number') {
                  this.getCityById(addressModel[a])
                    .then((cityName) => {
                      this.form[p + `_${a}`] = cityName
                    })
                } else {
                  this.form[p + `_${a}`] = addressModel[a]
                }
              }
            }
          } else {
            this.form[p] = model[p] || ''
          }
        }
        this.initialForm = JSON.stringify(this.form)
        this.dialogFormVisible = true
      },
      /**
       * Resets the form to its initial state
       */
      resetForm () {
        this.form = Object.assign({}, this.formInitState)
        this.form.address_state = Object.assign({}, { label: '', value: '' })
        this.$store.dispatch('isEditingForm', false)
      }
    },
    computed: {
      ...mapGetters({
        getStateById: 'getStateById',
        getAddressById: 'getAddressById',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions'
      }),
      data () {
        return this.sortData(this.$store.getters.getAllCompanies)
      },
      pageData () {
        return this.meetsFilterCriteria(this.data).slice((this.currentPage - 1) * 20, this.currentPage * 20)
      },
      states () {
        return this.$store.getters.getAllStates
      },
      banks () {
        return this.$store.getters.getAllBanks
      },
      meta () {
        return { count: this.meetsFilterCriteria(this.data).length, shown: this.pageData.length }
      },
      hasCreatePermission () {
        let createPermission = ['system.view_company', 'system.change_company']
        return this.checkIfUserHasRequiredPermissions(createPermission)
      },
      fields () {
        return [
          {
            label: 'Code',
            name: 'code',
            type: 'string',
            fieldType: 'input',
            required: true,
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Name',
            name: 'name',
            type: 'string',
            fieldType: 'input',
            required: true,
            msg: 'Please specify a name',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Tax ID',
            name: 'tax_id',
            type: 'string',
            fieldType: 'input',
            required: true,
            msg: 'Please specify a tax ID',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Phone',
            name: 'phone',
            type: 'string',
            fieldType: 'input',
            required: true,
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Active',
            name: 'active',
            type: 'boolean',
            fieldType: 'checkbox',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Bank',
            name: 'bank',
            type: 'string',
            fieldType: 'select',
            filterable: true,
            required: true,
            choices: [
              ...this.banks.map(bank => {
                return { display_name: bank.name, value: bank.id }
              })
            ],
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Comments',
            name: 'comments',
            type: 'string',
            fieldType: 'input',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Contact Name',
            name: 'contact_name',
            type: 'string',
            fieldType: 'input',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Email Address',
            name: 'email',
            type: 'email',
            fieldType: 'input',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Address line 1',
            name: 'address_line1',
            type: 'string',
            fieldType: 'input',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Address line 2',
            name: 'address_line2',
            type: 'string',
            fieldType: 'input',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Address city',
            name: 'address_city',
            type: 'string',
            fieldType: 'input',
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Address state',
            name: 'address_state',
            type: 'string',
            fieldType: 'select',
            filterable: true,
            choices: [
              ...this.states.map(state => {
                return { display_name: state.name, value: state.id }
              })
            ],
            disabled: !this.hasCreatePermission
          },
          {
            label: 'Address postal',
            name: 'address_postal',
            type: 'string',
            fieldType: 'input',
            disabled: !this.hasCreatePermission
          }
        ]
      }
    },
    /**
     * Pre-route enter logic.
     * @param to
     * @param from
     * @param next
     */
    async beforeRouteEnter (to, from, next) {
      try {
        if (from.path !== '/') {
          let dataLoader = new DataLoader(store, [ payload ], true, 200)
          await dataLoader.loadData()
        }
      } catch (e) {
        console.log(e)
      }
      next()
    },
    created () {
      this.endpoint = payload.endpoint
      this.moduleName = payload.moduleName
      this.payload = payload
    },
    async mounted () {
      this.$nextTick = () => {
        const tableHeight = () => {
          const parentHeight = document.getElementById('companies').offsetHeight
          const headerHeight = document.getElementById('companies-header').offsetHeight
          return parentHeight - headerHeight
        }
        this.tableHeight = tableHeight()
      }

      if (this.isCityModel === undefined) {
        await this.checkCityModel()
      }
    }
  }
</script>

<style>
  .el-dialog__header span {
    font-size: 22px;
    font-weight: 100;
  }
</style>

<style scoped>
  #companies-header {
    border-bottom: 1px solid lightgray;
  }
  .h-padded {
    padding: 0 12px;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
</style>
